'use strict';

var LevelSecondaryService = function LevelSecondaryService(strategyElementService) {
  function addWithLevelSecondaryService(newElement, collectionName) {
    var selectedRowType = strategyElementService.getSelectedRowType();
    var selectedGroup = strategyElementService.getSelectedGroup();
    var collection = selectedGroup[collectionName];
    if (selectedRowType === collectionName) {
      var selectedElement = strategyElementService.getSelectedElement();
      var insertionIndex = collection.indexOf(selectedElement);
      if (insertionIndex !== -1) {
        if (selectedElement.isEmpty()) {
          collection[insertionIndex] = newElement;
        } else {
          collection.splice(insertionIndex + 1, 0, newElement);
        }
      } else {
        addElementToCollection(newElement, collection);
      }
    } else {
      addElementToCollection(newElement, collection);
    }
    strategyElementService.selectRow(selectedGroup, newElement, collection, selectedRowType);
  }
  function addElementToCollection(newElement, collection) {
    if (isOneEmptyElementCollection(collection)) {
      collection[0] = newElement;
    } else {
      collection.push(newElement);
    }
  }
  function insertElement(strategyCondition) {
    var newConditionParams = {
      quantifier: 'AND',
      category: strategyCondition.category,
      criterion: strategyCondition.criterion,
      field: strategyCondition.field,
      operator: strategyCondition.operator,
      precision: strategyCondition.precision,
      isFieldValueRequired: strategyCondition.isFieldValueRequired
    };
    var newCondition = strategyElementService.createCondition(newConditionParams);
    addWithLevelSecondaryService(newCondition, 'conditions');
  }
  function clearSelection() {
    if (strategyElementService.getSelectedRowType() === 'actions') {
      return;
    }
    var group = strategyElementService.getSelectedGroup();
    strategyElementService.clearSelection();
    if (group) {
      strategyElementService.selectRow(group, group.actions[0], group.actions, 'actions');
    }
  }
  function isOneEmptyElementCollection(collection) {
    return collection.length === 1 && collection[0].isEmpty();
  }
  function createAction(params) {
    return strategyElementService.createAction(params);
  }
  return {
    insertElement: insertElement,
    clearSelection: clearSelection,
    createAction: createAction
  };
};
LevelSecondaryService.$inject = ['StrategyElementService'];
module.exports = LevelSecondaryService;